<script>
  export let item = [];
  export let group = "";
  export let isFlex = false;

  export let required = true;
  export let isDirty = false;
  export let isValid = false;
  export let label = '';
  export let marginRight ='';
  export let errorMessage = null;
  let error = '';
  export let ref = null;
    import { createEventDispatcher } from "svelte";
       const dispatch = new createEventDispatcher();
  $: {
    if (required) {
      if(group != null){
      isValid = true;
      dispatch("changed",group)
    }      
    else {
      error = errorMessage ? errorMessage : `Please select the ${label} of your child`;
      isValid = false;
    }
  }
  }

  const logClick=(i)=>{   
    let text = i.TextValue || i.text; 
  _paq.push(['trackEvent', 'Radio Input', `${label}[${text}]`]);
}
</script>
<div class="control">
  {#each item as i}
<div style="display:{isFlex? 'block':'inline'}; {marginRight != ''? `margin-right:${marginRight}`:'' }">
    <label class='radio' >
      <input
        aria-label={label}
        type="radio"
        bind:group
        value={i.value}
        on:click={() => {
          logClick(i);
          isDirty = true;
        }}
         disabled={i.disable || false}
        bind:this={ref} />
      {i.TextValue || i.text}
     
    </label>
    </div>
  {/each}

</div>
{#if !isValid && isDirty && error != ''}
  <span>
    <p class="help has-text-danger">{error}</p>
  </span>
{/if}